import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { ViewChild, ElementRef } from '@angular/core';

import { Ticket } from '@app/modules/model/ticket';

import { languageSupport, languageService } from '@app/modules/common/language';
import { viewService } from '@app/modules/view';

@Component({
    selector: 'ui-modal-cardpay',
    templateUrl:'./ui-card.html',
    styleUrls: [ 
        './ui-card.scss'
    ]
})
export class UiCardPayModal extends languageSupport implements OnInit, OnDestroy {
    public _tickets: Array<Ticket> = [];
    // Importe EXPLÍCITO a cobrar (p.ej. el tramo TARJETA de un pago mixto). Si es
    // null/0 se cobra el total del/los ticket(s) (comportamiento de siempre). Sin
    // esto, en un mixto el cobro manual pediría cobrar la venta ENTERA otra vez.
    public _saleAmount: number = null;

    get AmountToPay(){
        if (this._saleAmount != null && this._saleAmount > 0){
            return (Math.round(this._saleAmount * 100) / 100).toFixed(2);
        }
        let _totalprice = 0;
        for(let _ticket of this._tickets){
            _totalprice += _ticket.price;
        }
        _totalprice = Math.round(_totalprice * 100) / 100;

        return _totalprice.toFixed(2);
    }
        
    /************************/
    /* STARTS HERE          */
    /************************/

    constructor(private lang: languageService, private modalCtrl: ModalController, private params: NavParams, public view: viewService) {
        super(lang, null);
    }

    ngOnInit() {
        this._tickets = this.params.get('tickets');
        let _sa = this.params.get('saleAmount');
        this._saleAmount = (typeof _sa === 'number' && _sa > 0) ? _sa : null;
        let _amountpaid = 0;
        for(let _ticket of this._tickets){
            if ((_ticket.status == 'PP') && (_ticket.given)){
                _amountpaid += _ticket.given;
            }
        }
    }
    
    ngOnDestroy(){
        super.OnDestroy();
    }


    Price(price){
        let _parts = Math.abs(price).toString().split('.');

        let _int = _parts[0];
        let _dec = (_parts.length > 1) ? (_parts[1] + '0').slice(0, 2) : "00";

        return _int + ',' + _dec;
    }

    async AcceptModal() {
        await this.modalCtrl.dismiss(true);
    }    

    async CloseModal() {
        await this.modalCtrl.dismiss(false);
    }
}